// extracted by mini-css-extract-plugin
module.exports = {"wind":"Wind_wind__2Fa0D","direction":"Wind_direction__kLygh"};